import {
	MULTIMEDIA_GET_FILES,
	MULTIMEDIA_GET_FILES_SUCCESS,
	MULTIMEDIA_GET_FILES_FAILURE,
	MULTIMEDIA_CREATE_FILE,
	MULTIMEDIA_CREATE_FILE_SUCCESS,
	MULTIMEDIA_CREATE_FILE_FAILURE,
	MULTIMEDIA_SELECT_FILE,
	MULTIMEDIA_EDIT_FILE_SUCCESS,
	MULTIMEDIA_EDIT_FILE,
	MULTIMEDIA_EDIT_FILE_FAILURE,
	MULTIMEDIA_REMOVE_FILE,
	MULTIMEDIA_REMOVE_FILE_SUCCESS,
	MULTIMEDIA_REMOVE_FILE_FAILURE,
	MULTIMEDIA_UNSELECT_FILE,
	MULTIMEDIA_SELECT_FILES, MULTIMEDIA_PROPS_CHANGED,
} from "./actions";
import {debug, find, removeElem, updateElemByIndex} from "../../utility/functions";

const initialState = {
	loading: false,
	files: null,
	pagination: null,
	filter: null,
	selectedFiles: [],
	editing: false,
	adding: false,
	removing: false,
	name_all: "",
	names: [],
	author_all: "",
	authors: [],
	filesPicked: [],
	selectedFilePicked: 0,
	name: "",
	author: "",
	file: null,
	index: null,
	uploading: false,
	search: null,
};


export const multimediaReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case MULTIMEDIA_GET_FILES:
			return {
				...state,
				loading: true,
			};
		case MULTIMEDIA_GET_FILES_SUCCESS:
			return {
				...state,
				loading: false,
				files: action.files,
				pagination: action.pagination,
			};
		case MULTIMEDIA_GET_FILES_FAILURE:
			return {
				...state,
				loading: false,
			};
		case MULTIMEDIA_CREATE_FILE:
			debug("HERE");
			return {
				...state,
				uploading: true,
			};
		case MULTIMEDIA_CREATE_FILE_SUCCESS:
			return {
				...state,
				files: [...action.files, ...state.files],
				uploading: false,
				adding: false,
				name_all: "",
				names: [],
				author_all: "",
				authors: [],
				filesPicked: [],
				selectedFilePicked: 0,
			};
		case MULTIMEDIA_CREATE_FILE_FAILURE:
			return {
				...state,
				uploading: false,
			};
		case MULTIMEDIA_EDIT_FILE:
			return {
				...state,
				uploading: true,
			};
		case MULTIMEDIA_EDIT_FILE_SUCCESS: {
			return {
				...state,
				editing: false,
				uploading: false,
				files: updateElemByIndex(state.files, action.file, state.index)
			}
		}
		case MULTIMEDIA_EDIT_FILE_FAILURE: {
			return {
				...state,
				uploading: false,
			}
		}
		case MULTIMEDIA_REMOVE_FILE:
			return {
				...state,
				uploading: true,
			};
		case MULTIMEDIA_REMOVE_FILE_SUCCESS: {
			return {
				...state,
				removing: false,
				uploading: false,
				name: "",
				author: "",
				file: null,
				files: removeElem(state.files, 'id', find(action.file, 'id'))
			}
		}
		case MULTIMEDIA_REMOVE_FILE_FAILURE: {
			return {
				...state,
				uploading: false,
			}
		}
		case MULTIMEDIA_SELECT_FILE:
			return {
				...state,
				selectedFiles: [...state.selectedFiles, action.file],
			};
		case MULTIMEDIA_UNSELECT_FILE:
			return {
				...state,
				selectedFiles: removeElem(state.selectedFiles, 'id', find(action.file, 'id'))
			};
		case MULTIMEDIA_SELECT_FILES:
			return {
				...state,
				selectedFiles: [state.selectedFiles, action.files]
			};
		case MULTIMEDIA_PROPS_CHANGED:
			return {
				...state,
				...action,
			};
		default:
			return state;
	}
};